import React from 'react';
import PropTypes from 'prop-types';

import BorderlessButton from '../../../../common/buttons/BorderlessButton';
import { getUnassignedPillStyles } from './timeTrackingGridHelpers';

export default function UnassignedEquipmentPills({
  relevantData,
  responding,
  compact,
  onPress,
}) {
  const { label, pillClassName, pillTextClassName } = getUnassignedPillStyles(relevantData?.hours);
  const wrapClassName = [
    'ttg-unassigned-cell-wrap',
    'ttg-unassigned-cell-wrap-unassigned',
    compact && 'ttg-unassigned-cell-wrap-compact',
  ].filter(Boolean).join(' ');

  const columnClassName = [
    'ttg-unassigned-pill-column',
    compact && 'ttg-unassigned-pill-column-compact',
  ].filter(Boolean).join(' ');

  const rowClassName = [
    'ttg-unassigned-pill-row',
    compact && 'ttg-unassigned-pill-row-compact',
  ].filter(Boolean).join(' ');

  const pill = (
    <div className={rowClassName}>
      <div
        className={[
          pillClassName,
          !responding && 'ttg-unassigned-pill-readonly',
        ].filter(Boolean).join(' ')}
      >
        <span className={pillTextClassName}>{label}</span>
      </div>
    </div>
  );

  if (!responding) {
    return (
      <div className={wrapClassName}>
        <div className={columnClassName}>{pill}</div>
      </div>
    );
  }

  return (
    <div className={wrapClassName}>
      <BorderlessButton
        className={`${columnClassName} ttg-unassigned-pill-button`}
        iconLeft
        iconNode={pill}
        onClick={onPress}
        style={{ width: '100%', height: 'auto', padding: 0 }}
      />
    </div>
  );
}

UnassignedEquipmentPills.propTypes = {
  relevantData: PropTypes.object.isRequired,
  responding: PropTypes.bool.isRequired,
  compact: PropTypes.bool.isRequired,
  onPress: PropTypes.func.isRequired,
};
